import { buildAlgoliaExperienceObjectID, sendAlgoliaInsightsEvent } from '@/wabunka-src/common/utils/algolia/algoliaInsights';

/**
 * 体験詳細ページ表示時に送信する Click イベント。
 * Related Products モデルの学習に寄与する。
 */
export const sendAlgoliaExperienceViewedEvent = (experienceId: string) => {
  sendAlgoliaInsightsEvent('clickedObjectIDs', 'Experience Viewed', [buildAlgoliaExperienceObjectID(experienceId)]);
};
